import footerPhoneIcon from "@assets/footer/phoneIcon.svg";
import { Link } from "react-router";

type FooterAdvertiseProps = {
  testId?: string;
};

export function FooterAdvertise({ testId }: FooterAdvertiseProps) {
  return (
    <div
      data-testid={`${testId}-advertise`}
      className="grid gap-2.5 md:float-right w-full xmd:w-1/2 text-sm font-normal not-italic leading-5 tracking-normal text-grey-100 font-opensans px-1.5 lg:px-0"
    >
      <div className="flex gap-1">
        <span>For Advertising: </span>
        <Link
          className="text-red-100 hover:text-red-200 hover:underline"
          target="_blank"
          to="https://www.sph.com.sg/contact-us/?ctopic=advertising&csubject=general%20advertising"
        >
          Contact Us
        </Link>
      </div>

      <div className="grid gap-1.5">
        <div className="text-xs font-normal">
          <img
            height={20}
            width={20}
            loading="lazy"
            alt="footer-phone-icon-1"
            src={footerPhoneIcon}
            className="inline"
          />{" "}
          : Mr.Kalim: (65) 98633894{" "}
        </div>
        <div className="text-xs font-normal">
          <img
            height={20}
            width={20}
            loading="lazy"
            alt="footer-phone-icon-2"
            src={footerPhoneIcon}
            className="inline"
          />{" "}
          : Mrs.Maheshwari: (65) 9366 5277
        </div>
      </div>
      <div className="text-xs leading-4.5 not-italic font-opensans">
        Explore advertising opportunities with{" "}
        <Link
          className="text-red-100 hover:text-red-200 hover:underline"
          target="_blank"
          to="https://www.sph.com.sg/advertising-solutions/"
        >
          SPH Media
        </Link>
        .
      </div>
    </div>
  );
}
